import { gql } from '@apollo/client';
import {
  AnalysisMetaFieldsFragment,
  ComparisonConfigFieldsFragment,
} from '../fragments';
import {
  DataTableQueryFieldsFragment,
  ExpressionQueryFieldsFragment,
  FunnelQueryFieldsFragment,
  PathQueryFieldsFragment,
  PredictionQueryFieldsFragment,
  RetentionQueryFieldsFragment,
} from '../../builderFragments';
import { ErrorFragment } from '../../fragments';
import { CohortSampleQueryFragment } from '../../cohorts';

export const EXECUTE_QUERY = gql`
  mutation QueryExecute($input: QueryExecuteInput!) {
    queryExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...ExpressionQueryFields
        }
        ... on Expression {
          geo
          comparisonConfig {
            ...ComparisonConfigFields
          }
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${ExpressionQueryFieldsFragment}
  ${ErrorFragment}
  ${ComparisonConfigFieldsFragment}
`;

export const EXECUTE_FUNNEL = gql`
  mutation FunnelExecute($input: FunnelExecuteInput!) {
    funnelExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...FunnelQueryFields
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${FunnelQueryFieldsFragment}
  ${ErrorFragment}
`;

export const EXECUTE_PATH = gql`
  mutation pathExecute($input: PathExecuteInput!) {
    pathExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...PathQueryFields
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${PathQueryFieldsFragment}
  ${ErrorFragment}
`;

export const EXECUTE_RETENTION = gql`
  mutation retentionExecute($input: RetentionExecuteInput!) {
    retentionExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...RetentionQueryFields
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${RetentionQueryFieldsFragment}
  ${ErrorFragment}
`;

export const EXECUTE_PREDICTION = gql`
  mutation PredictionExecute($input: PredictionExecuteInput!) {
    predictionExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...PredictionQueryFields
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${PredictionQueryFieldsFragment}
  ${ErrorFragment}
`;

export const EXECUTE_DATA_TABLE = gql`
  mutation DataTableExecute($input: DataTableExecuteInput!) {
    dataTableExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...DataTableQueryFields
        }
        ... on DataTable {
          comparisonConfig {
            ...ComparisonConfigFields
          }
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${DataTableQueryFieldsFragment}
  ${ErrorFragment}
  ${ComparisonConfigFieldsFragment}
`;

export const EXECUTE_COHORT = gql`
  mutation CohortExecute($input: CohortExecuteInput!) {
    cohortExecute(input: $input) {
      entity {
        ...AnalysisMetaFields
        query {
          ...CohortSampleQueryFields
        }
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${AnalysisMetaFieldsFragment}
  ${CohortSampleQueryFragment}
  ${ErrorFragment}
`;
